module.exports = __webpack_public_path__ + "static/media/logo-0.774a1670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-0.svg
// module id = 805
// module chunks = 0